export default {
  "home": "HOME",
  "news": "NEWS",
  "community": "COMMUNITY",
  "character": "CHARACTERS",
  "world": "WORLD",
  "features": "FEATURES",
  "topUp": "TOP UP",
  "customerService": "CUSTOMER",
  "download": "DOWNLOAD",
  "moreDownload": "More download methods",
  "screenshot": "SCREENSHOT",
  "video": "CINEMATIC",
  "poster": "POSTER",
  "downloadGame": "DOWNLOAD",
  "scan": "Scan QR code to download",
  "prev": "Previous",
  "next": "Next",
  "latest": "LATEST",
  "moreNews": "INFORMATION",
  "fwtk": "TERMS OF SERVICE",
  "yszc": "PRIVACY POLICY",
  "noContent": "No content yet",
  "goPay": "GO NOW",
  "payGuide": "LEARN MORE",
  "stayTurn": "Stay tuned!",
  "huoyi": "Fire Ant",
  "huoyi_text": "Fire Ant is one of the most infamous invasive species in the world, fearsome to all smaller ants alike.\r\nIn contrast to their small size of a general length of 4-6 millimeters that make them seem harmless, they are very aggressive and destructive.",
  "huoyi_skill1": "Tactics",
  "huoyi_skill2": "Haste Soldier HP",
  "huoyi_skill3": "Haste Soldier DEF",
  "huoyi_skill4": "Haste Soldier ATK ",
  "ciyi": "Amber Stinger",
  "ciyi_text": "Polyrhachis trapezoidea, commonly found in Australia's open Eucalyptus forests and savanna woodlands, golden to orange red bristles covering its back.\r\nThe edges have symmetrical spine like carapace protruding from them, the outer carapace is hard andis a good defense against external enemies.",
  "ciyi_skill1": "Tactics",
  "ciyi_skill2": "Ranged Soldier HP",
  "ciyi_skill3": "Ranged Soldier DEF",
  "ciyi_skill4": "Ranged Soldier ATK ",
  "hongyi": "Meat Ant",
  "hongyi_text": "Monomorium sp, a mysterious species, which has not yet been accurately named, can reach around 8mm in length and has a very recognizable blood spot on its back.",
  "hongyi_skill1": "Research Speed",
  "hongyi_skill2": "Training Speed",
  "hongyi_skill3": "Max Army Scale",
  "jinjia": "Harvester",
  "jinjia_text": "Daceton armigerum, found in Amazon rain forests in northern South America, is carnivores.\r\nThe size of these ants varies between worker and soldier ants, which soldier ant can reach up to 15-17 mm.\r\nTheir diet is very diverse, from a variety of insects to small snails.\r\nThey can not only tear their prey with strong and powerful teeth, but also sting and inject venom to better break down the prey.",
  "jinjia_skill1": "Tactics",
  "jinjia_skill2": "Melee Soldier HP",
  "jinjia_skill3": "Melee Soldier DEF",
  "jinjia_skill4": "Melee Soldier ATK ",
  "gongbei": "Carpenter",
  "gongbei_text": "Camponotus mirabilis is only found in parts of the northern South America, and is called the ghosts of the Amazon rain forests.\r\nThey normally breed aphids in the bamboo joints to gather honeydew as their food, but will occasionally also prey on other insects.",
  "gongbei_skill1": "Training Speed",
  "gongbei_skill2": "Food Required for Training Down",
  "gongbei_skill3": "Stamina Cost Down",
  "specialAnt": "SPECIALIZED ANT",
  "back": "Back",
  "guide": "GUIDE",
  "announcement": "ANNOUNCEMENT",
  "event": 'EVENT',
}
